import { baseApi, METHODS } from '../baseApi';
import { getConditionalUrlAndHeaders } from '../helpers';
import { ApiArgs, PaginatedResult } from '../types';

import {
  OrderDates,
  StoreDetails,
  StoreSearchDetails,
  StoreSearchPayload,
} from './types';

export const TAGS = {
  STORE_DETAILS: 'storesDetails',
  STORES: 'stores',
};
export const storeApi = baseApi
  .enhanceEndpoints({ addTagTypes: Object.values(TAGS) })
  .injectEndpoints({
    endpoints: (builder) => ({
      getOrderDates: builder.query<OrderDates, ApiArgs<void, string>>({
        query: (params) => ({
          method: 'GET',
          ...getConditionalUrlAndHeaders({
            url: `/store/${params.payload}/order-dates`,
            urlBranded: `/branded-website/stores/${params.payload}/date-options?v=2`,
            headers: { 'x-api-version': '1' },
          }),
        }),
      }),
      getStoreDetails: builder.query<StoreDetails, ApiArgs<void, string>>({
        providesTags: [TAGS.STORE_DETAILS],
        query: (params) => ({
          method: METHODS.GET,
          ...getConditionalUrlAndHeaders({
            url: `/store/${params.payload}`,
            urlBranded: `/branded-website/stores/${params.payload}/info`,
            headers: { 'x-api-version': '1' },
          }),
        }),
      }),
      getStores: builder.query<
        PaginatedResult<StoreSearchDetails>,
        ApiArgs<void, StoreSearchPayload>
      >({
        providesTags: [TAGS.STORES],
        query: (params) => ({
          url: '/store/search',
          method: METHODS.GET,
          headers: { 'x-api-version': '1' },
          params: params.payload,
        }),
      }),
    }),
    overrideExisting: true,
  });

export const {
  useGetOrderDatesQuery,
  useGetStoreDetailsQuery,
  useGetStoresQuery,
} = storeApi;
